import { useEffect } from 'react';
import { UnifiedInstruments } from '#/unified-rfqs/ui/instruments/types';
import * as store from './store';
import { Actions } from './actions';
import { isHedgeLeg } from './leg-functions';

export default function useHedgeLegPricePrefill(
  state: store.State,
  actions: Actions,
) {
  useEffect(() => {
    state.legs.forEach((leg, idx) => {
      if (!isHedgeLeg(leg)) return;
      if (leg.price !== null) return; // explicit check for the null as string identifying "price not initialized or changed by user"

      const hedgeInstrument = (
        ins: UnifiedInstruments['futureInstruments'][number],
      ) =>
        ins.base_currency === leg.currency &&
        ins.margin_kind === leg.marginKind &&
        ins.expiration === leg.expiration &&
        ins.venue === state.venue;
      const instrument =
        state.instruments.futureInstruments.find(hedgeInstrument);
      const markPrice = instrument?.mark_price;

      if (markPrice == null) return;

      actions.changeLegPrice(idx, markPrice);
    });
  }, [actions, state.instruments.futureInstruments, state.legs, state.venue]);
}
